import React, { useEffect, useState } from 'react';

import styles from './styles.module.scss';

import { useGetUser } from '../../hooks/useGetUser';

import homeMainImg from '../../assets/img/homeMain.png'
import HomeCardCampanha from '../../components/HomeCardCampanha'
import { getCardCampanha } from '../../services/api-auto';
import Banner from '../../components/Banner'


const Home = props => {

  const user = useGetUser()
  const [campanhas, setCampanhas] = useState([])
  const [paginacao, setPaginacao] = useState(0)
  const [mais, setMais] = useState(true)
  

  const getListCampanhas = async() =>{
    const list = await getCardCampanha(paginacao + 1)
    if(!Boolean(list.length)){ setMais(false) }
    setCampanhas( [...campanhas, ...list])
    setPaginacao( paginacao + 1)
  }

  const showPagination = async () => {
    const list = await getCardCampanha(paginacao + 1)
    Boolean(list.length) ? setMais(true) : setMais(false)
  }
  
  useEffect(()=>{
    showPagination();
  },[paginacao])

  
  useEffect(() => {
    getListCampanhas()
  }, []);

  return (
    <div className={styles.pageHome}>
      <div className={styles.mainBannerWrapper}>
        <Banner screen={'home'}/>
      </div>
      <div className={styles.white}>
        <div className={styles.programasWrapper}>
          <div className={styles.title}>
            Quer ganhar mais benefícios? É fácil! Seja um parceiro ativo e participe das nossas campanhas😉
          </div>
        </div>
        <div className={styles.displayCampanhaWrapper}>
          <div className={styles.cards}>
            {
              campanhas.map((campanha) =>{
                return (<HomeCardCampanha campanha={campanha}/>)
              })
            }
          </div>
          {
            mais && (
              <div className={styles.verMaisWrapper}>
                <button className={`customButton ${styles.verMaisButton}`} onClick={getListCampanhas} >
                  Ver mais
                </button>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
  
}

export default Home;